import type { BadgeColor } from '#ui/types'

export const roleOptions: { label: string, color: BadgeColor, value: ELmsRole }[] = [
  { label: 'Siswa', color: 'violet', value: ELmsRole.STUDENT }
  // { label: 'Admin LMS', color: 'blue', value: ELmsRole.ADMIN },
  // { label: 'Widyaiswara', color: 'emerald', value: ELmsRole.TEACHER }
]
export const genderOptions = [
  { label: 'Laki-laki', value: EGender.MALE },
  { label: 'Perempuan', value: EGender.FEMALE }
]
export const unitKerjaTypeOptions = [
  { label: 'Unit Kerja SimPeg', value: EUnitKerjaType.SIMPEG },
  { label: 'Lain-lain', value: EUnitKerjaType.CUSTOM }
]
export const unitOrganisasiTypeOptions = [
  { label: 'Unit Organisasi SimPeg', value: EUnitKerjaType.SIMPEG },
  { label: 'Lain-lain', value: EUnitKerjaType.CUSTOM }
]
export const jabatanTypeOptions = [
  { label: 'Jabatan Kepala', value: EJabatanType.KEPALA },
  { label: 'Jabatan Fungsional Umum / Tertentu', value: EJabatanType.FUNGSIONAL },
  { label: 'Lain-lain', value: EJabatanType.CUSTOM }
]

export const lmsRoleLabelMap: Record<ELmsRole, string> = {
  [ELmsRole.STUDENT]: 'Siswa',
  [ELmsRole.ADMIN]: 'Admin LMS',
  [ELmsRole.TEACHER]: 'Widyaiswara'
}
